<template>
    <FaqDefault :slice="props.slice" is-faq-with-image>
        <template #image>
            <PrismicImage
                v-if="isFilled.image(slice.primary.image)"
                :field="slice.primary.image"
                class="slice-faq--with-image__image"
                data-testid="slice-faq-image"
            />
        </template>
    </FaqDefault>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {isFilled} from '@prismicio/helpers';
    import {getSliceComponentProps, PrismicImage} from '@prismicio/vue';
    import type {FaqSlice, FaqSliceFaqWithImage} from '@prismicio-types';
    import FaqDefault from './FaqDefault.vue';

    const props = defineProps(getSliceComponentProps<FaqSlice>());
    const slice = computed(() => props.slice as FaqSliceFaqWithImage);
</script>
